import {
  SkeletonBlock,
  SkeletonLine,
  Timeline,
  TimelineContent,
  TimelineItem,
  TimelineSide,
} from "@opensea/ui-kit"
import { range } from "es-toolkit"

export const ActionTimelineSkeleton = ({ count = 1 }: { count?: number }) => {
  return (
    <Timeline>
      {range(count).map(i => (
        <TimelineItem key={i}>
          <SkeletonBlock className="size-6 rounded" />
          <TimelineContent>
            <SkeletonLine className="h-3 w-[80px]" />
          </TimelineContent>
          <TimelineSide>
            <SkeletonLine className="h-5 w-[50px] rounded" />
          </TimelineSide>
        </TimelineItem>
      ))}
    </Timeline>
  )
}
